function myFunction() {

    document.getElementById("fst_btn").classList.remove("active");
    document.getElementById("snd_btn").classList.remove("active");
    document.getElementById("trd_btn").classList.remove("active");
    this.onclick = e => {

        if (e.target.id == 'fst_btn' || e.target.id == 'snd_btn' || e.target.id == 'trd_btn') {

            var mprice = e.target.dataset.mprice;
            var nprice = e.target.dataset.nprice;
            var msave = e.target.dataset.msave;
            var mshipping = e.target.dataset.shipping;
            var nlink = e.target.dataset.hlink;
            document.getElementsByClassName("price6_origin")[0].textContent = mprice;
            document.getElementsByClassName("price6_origin")[1].textContent = mprice;
            document.getElementById("nprice").innerHTML = nprice;
            document.getElementById("moneysave").innerHTML = 'You Save: ' + msave;
            document.getElementById("shipping").innerHTML = mshipping;
            document.getElementById("link").href = nlink;
            e.target.classList.add("active");
        }
    }
}

$(function() {
    $('#fst_btn').click(function() {
        $(this).css('background', '#66cbff ')
        $('#snd_btn').css('background', '#eee')
        $('#trd_btn').css('background', '#eee')
    });
});

$(function() {
    $('#snd_btn').click(function() {
        $(this).css('background', '#66cbff ')
        $('#fst_btn').css('background', '#eee')
        $('#trd_btn').css('background', '#eee')
    });
});


$(function() {
    $('#trd_btn').click(function() {
        $(this).css('background', '#66cbff ')
        $('#snd_btn').css('background', '#eee')
        $('#fst_btn').css('background', '#eee')
    });
});